import localForage from 'localforage';
var store = localForage.createInstance({
    name: 'i18nspect',
    version: 1.0,
    storeName: 'i18nspect',
    description: 'i18nspect storage',
});
export default store;
